import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { getProjectId, pathsObj } from '../lib/common';

export default function NoDataView({ pageName }) {
  const navigate = useNavigate();
  const projectId = getProjectId();
  const location = useLocation();
  const pageType = location.pathname.replace('/csportal', '').replace('/', '') || '';
  setTimeout(() => {
    if (projectId === 'csportal') {
      navigate('/csportal');
    } else {
      navigate('/genio');
    }
  }, 2000);
  return (
    <div>
      <div className="font14 fw500 text-center" style={{ marginTop: '30vh' }}>
        Cannot find <span className="fw600">{pageName || pathsObj?.[pageType] || ''}</span> for your profile
      </div>
    </div>
  );
}
NoDataView.propTypes = {
  pageName: PropTypes.string,
};
